import LoadingState from '../../../values/loading-state-enum'
import {type LocationIdType} from '../locations/state'
import {SortDirection} from '../my-vessels-filters/types/my-vessel-filter-state'
import {type SortValue} from '../vessel-filter/types/vessel-filter-state'

export interface ReportsFilterReduxState {
    loadingState: LoadingState
    selectedReportType: string | undefined
    selectedFromTimeRange: string | undefined
    selectedToTimeRange: string | undefined
    includeWholeFleetReports: boolean
    locations: Set<LocationIdType> | undefined
    searchVesselTagTerm: string[]
    searchVesselNameTerm: string
    searchVesselTerm: string
    showXButton: boolean
    vesselSort: SortValue
    selectedFilterName: string
    textSearch: string | undefined
}

export const DEFAULT_REPORTS_FILTER_STATE: ReportsFilterReduxState = {
    loadingState: LoadingState.NotPopulated,
    selectedFromTimeRange: '',
    selectedToTimeRange: '',
    selectedReportType: '',
    includeWholeFleetReports: true,
    locations: undefined,
    searchVesselTagTerm: [],
    searchVesselNameTerm: '',
    searchVesselTerm: '',
    showXButton: false,
    vesselSort: {
        field: 'vessel-name',
        direction: SortDirection.DESC,
    },
    selectedFilterName: 'Saved filters',
    textSearch: undefined,
}
